import React from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { TFunction } from "i18next";
import {
  PhotoTagCreateParams,
  usePhotoTagCreate,
} from "../../../../hooks/api/photoTags";
import { useMessageError } from "../../../../hooks/common";

interface CreateTagModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  t: TFunction;
}

export function CreateTagModal({
  open,
  onClose,
  onSuccess,
  t,
}: CreateTagModalProps): React.ReactElement {
  const [form] = Form.useForm();
  const photoTagCreate = usePhotoTagCreate();

  const handleSubmit = async (values: PhotoTagCreateParams) => {
    try {
      await photoTagCreate.fetch(values);
      message.success("Tag added");
      form.resetFields();
      onSuccess();
      onClose();
    } catch (error) {
      // message.error(t("common.error.create"));
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  useMessageError([photoTagCreate]);

  return (
    <Modal
      title="Add new tag"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {t("common.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => form.submit()}
          loading={photoTagCreate.loading}
        >
          Add tag
        </Button>,
      ]}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Tag name"
          name="name"
          rules={[
            { required: true, message: "This field is required" },
            { max: 100, message: "Maximum length is 100 characters" },
          ]}
        >
          <Input placeholder="Please enter" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
